var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RecentlyCalledContracts',{staticClass:"mt-4",attrs:{"hide-pagination-count":"","network":_vm.network,"contractsNumber":_vm.contractsNumber,"items-per-page":10,"pageable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }